import { createContext, useContext, useState } from 'react'

const AIContext = createContext(null)

export function AIProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false)
  const [context, setContext] = useState({})

  const openAI = (initialContext = {}) => {
    setContext(initialContext)
    setIsOpen(true)
  }

  const closeAI = () => {
    setIsOpen(false)
  }

  const value = {
    isOpen,
    context,
    openAI,
    closeAI
  }

  return (
    <AIContext.Provider value={value}>
      {children}
    </AIContext.Provider>
  )
}

export function useAI() {
  const context = useContext(AIContext)
  if (!context) {
    throw new Error('useAI must be used within an AIProvider')
  }
  return context
}
